"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_native_popup_menu_1 = require("react-native-popup-menu");

exports.PopupProvider = react_native_popup_menu_1.MenuProvider;